import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "./../index";
import { Modal } from "antd";
import Close from "./../../../assets/suc-khoe-vang/dateclose.png";
import Chevronmo from "./../../../assets/suc-khoe-vang/chevronmo.png";
import Chevrondong from "./../../../assets/suc-khoe-vang/chevrondong.png";
import Iback from "./../../../assets/suc-khoe-vang/iBack.png";
import Helper from "./../../../extra/helper";
import IDong from "./../../../assets/suc-khoe-vang/iDong.png";

const ModalBenifitsDetail = (props) => {
  const { dataIsu, arrItem } = useContext(AuthContext);
  const [openql1, setOpenql1] = useState(true);
  const [openqlbosung, setOpenqlbosung] = useState(true);
  const Benefits = props?.formData || dataIsu;
  const benefits = Helper.Benefits[+dataIsu?.packageId - 1];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "95%",
        }}
        centered={true}
        footer={false}
        closable={false}
        open={props.open}
        onCancel={props.handleCancel}
        maskStyle={{ background: "#000000", opacity: 0.8 }}
      >
        <div
          style={{
            borderBottom: "1px solid #dddddd",
            fontWeight: 500,
            fontSize: 16,
            padding: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "sticky",
            top: 0,
            backgroundColor: "#FFF",
            borderRadius: "15px 15px 0px 0px",
          }}
        >
          <div>
            <img
              onClick={() => props.handleCancel()}
              src={Iback}
              alt="Global Care"
              width={25}
            />
          </div>
          <div style={{ width: "90%", textAlign: "center", fontWeight: 600 }}>
            Chi tiết quyền lợi
          </div>
          <div>
            <img
              onClick={() => props.handleCancel()}
              src={Close}
              alt="Global Care"
              width={20}
            />
          </div>
        </div>
        <div style={{ padding: 10 }}>
          {props?.showPacked && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <div style={{ marginRight: 10 }}>
                <img src={arrItem[dataIsu?.packageId - 1].icon} style={{ width: 67, height: 71 }} />
              </div>
              <div style={{ width: "100%" }}>
                <div style={{ fontWeight: 600, color: "#009B4B" }}>
                  {arrItem[dataIsu?.packageId - 1].title}
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Phí bảo hiểm:</span>
                  <span style={{ fontWeight: 500, color: "#009B4B" }}>
                    {Helper._formatMoney(arrItem[dataIsu?.packageId - 1].fee)} VNĐ
                  </span>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>Thời hạn BH</span>
                  <span>1 năm</span>
                </div>
              </div>
            </div>
          )}
          <div
            onClick={() => setOpenql1(!openql1)}
            style={{
              color: "#009B4B",
              fontWeight: 600,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "-moz-initial",
            }}
          >
            <div>Quyền lợi chính:</div>
            <div>
              <img
                src={openql1 ? Chevrondong : Chevronmo}
                alt="Global Care"
                width={13}
              />
            </div>
          </div>
          <div style={{ display: openql1 ? "" : "none" }}>
            <table style={{ width: "100%", marginTop: 10 }}>
              <tr>
                <th
                  style={{
                    width: "75%",
                    textAlign: "center",
                    borderRadius: "10px 0px 0px 0px",
                  }}
                >
                  Quyền lợi
                </th>
                <th
                  style={{
                    textAlign: "center",
                    borderRadius: "0px 10px 0px 0px",
                  }}
                >
                  Số tiền BH (VNĐ)
                </th>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  1. Bảo hiểm tử vong, thương tật toàn bộ vĩnh viễn do tai nạn
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.ql1}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  2. Bảo hiểm tử vong, thương tật toàn bộ vĩnh viễn do bệnh
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.ql2}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  3. Chi phí y tế do tai nạn
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.ql3}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  4. Bảo hiểm điều trị nội trú, phẫu thuật do bệnh
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.ql4}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  4.1 Chi phí nằm viện/ngày (tối đa 60 ngày/năm)
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.ql41}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <b>Quyền lợi bảo hiểm:</b>
                  <ul style={{ margin: 0 }}>
                    <li>Tiền giường, tiền ăn theo tiêu chuẩn tại bệnh viện.</li>
                    <li>Chi phí hành chính, chi phí máu, huyết tương.</li>
                    <li>Thuốc và các dược phẩm sử dụng trong khi nằm viện.</li>
                    <li>Băng, nẹp thông thường và bột;</li>
                    <li>Chi phí xét nghiệm hoặc chẩn đoán.</li>
                    <li>
                      Các chi phí y tế khác trong thời gian nằm viện (Bao gồm cả
                      điều trị trong ngày và điều trị cấp cứu có phát sinh chi
                      phí giường được áp dụng như điều trị trong ngày).
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlbaohiem}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>4.2 Chi phí phẫu thuật</td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.ql42}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <b>Quyền lợi bảo hiểm:</b>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Phẫu thuật nội trú, phẫu thuật trong ngày, phẫu thuật
                      ngoại trú do bệnh
                    </li>
                    <li>
                      Phẫu thuật liên quan đến cấy ghép nội tạng (không bao gồm
                      chi phí mua bộ phận).
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlbaohiem42}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <b>4.3 Các quyền lợi khác</b>
                </td>
                <td></td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Chi phí điều trị trước khi nhập viện/ngày (tối đa 30 ngày
                      trước khi nhập viện/năm).
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlkhac1}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Chi phí điều trị sau khi xuất viện/ngày (tối đa 30 ngày kể
                      từ ngày xuất viện/năm).
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlkhac2}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Chi phí y tá chăm sóc tại nhà ngay sau khi xuất viện/ngày
                      (tối đa 15 ngày/năm).
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlkhac3}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>Trợ cấp nằm viện/ngày tại các cơ sở y tế công lập (tối đa 60 ngày/năm).</li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlkhac4}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Dịch vụ xe cứu thương trong lãnh thổ Việt nam, loại trừ
                      bằng đường hàng không.
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlkhac5}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Trợ cấp mai táng phí trong trường hợp tử vong tại bênh
                      viện.
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlkhac6}
                </td>
              </tr>
            </table>
          </div>
          <div
            onClick={() => setOpenqlbosung(!openqlbosung)}
            style={{
              color: "#009B4B",
              fontWeight: 600,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "-moz-initial",
              marginTop: 10,
            }}
          >
            <div>Quyền lợi bổ sung:</div>
            <div>
              <img
                src={openqlbosung ? Chevrondong : Chevronmo}
                alt="Global Care"
                width={13}
              />
            </div>
          </div>
          <div style={{ display: openqlbosung ? "" : "none" }}>
            <table style={{ width: "100%", marginTop: 10 }}>
              <tr>
                <th
                  style={{
                    // width: "75%",
                    textAlign: "center",
                    borderRadius: "10px 0px 0px 0px",
                  }}
                >
                  Quyền lợi
                </th>
                <th
                  style={{
                    width: "140px",
                    textAlign: "center",
                    borderRadius: "0px 10px 0px 0px",
                  }}
                >
                  Số tiền BH (VNĐ)
                </th>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  1. Thai sản (Không bao gồm chi phí khám thai định kỳ, áp dụng
                  đồng chi trả)
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_01?.[0]===1?benefits?.qlbs1 : 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>1.1 Sinh thường.</td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs11:'Không hỗ trợ'}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>1.2 Sinh mổ.</td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs12:'Không hỗ trợ'}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>1.3 Tai biến sản khoa.</td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs13:'Không hỗ trợ'}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  1.4 Bất thường trong quá trình mang thai và các bệnh lý phát
                  sinh nguyên nhân do thai kỳ.
                </td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs14:'Không hỗ trợ'}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  1.5 Chi phí khám trước khi sinh (lần khám cuối cùng trong vòng
                  30 ngày trước khi đẻ).
                </td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs15:'Không hỗ trợ'}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  1.6 Chi phí điều trị ngay sau khi xuất viện và /hoặc 1 lần tái
                  khám (trong vòng 14 ngày sau khi sinh).
                </td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs16:'Không hỗ trợ'}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  1.7 Chi phí Chăm sóc trẻ sau sinh/năm (trong vòng 07 ngày sau
                  sinh).
                </td>
                <td style={{ textAlign: "center" }}>
                  <b>{dataIsu?.additional_01?.[0]===1?benefits?.qlbs17: 0}</b>
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  2. Bảo hiểm điều trị ngoại trú
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_02?.[0]===1?benefits?.qlbs2: 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  Chi phí điều trị ngoại trú
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_02?.[0]===1?benefits?.qlbs2ngoaitru: 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>
                      Chi phí khám bệnh, tiền thuốc theo kê đơn của bác sĩ, tiền
                      chụp Xquang và làm các xét nghiệm theo chỉ định của bác
                      sĩ. Trị liệu bức xạ, liệu pháp ánh sáng, vật lý trị liệu
                      và các phương pháp điều trị tương tự (bao gồm cả điều trị
                      cấp cứu ngoại trú)
                    </li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_02?.[0]===1?benefits?.qlbs2khambenh: "Không hỗ trợ"}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  3. Nha khoa (áp dụng đồng chi trả)
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_03?.[0]===1?benefits?.qlbs3: 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  Chi phí chăm sóc răng ngoại trú
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_03?.[0]===1?benefits?.qlbs3ngoaitru: 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontSize: 12 }}>
                  <ul style={{ margin: 0 }}>
                    <li>Khám và chẩn đoán.</li>
                    <li>Viêm lợi (nướu)/ viêm nha chu.</li>
                    <li>Chụp X-Quang và cận lâm sang .</li>
                    <li>
                      Trám răng bằng chất liệu thông thường (amalgam, composite,
                      fuji...)
                    </li>
                    <li>Điều trị tủy.</li>
                    <li>
                      Nhổ răng bệnh lý (bao gồm tiểu phẫu), phẫu thuật cắt chóp
                      răng, lấy u vôi răng.
                    </li>
                    <li>Lấy cao răng (Cạo vôi răng), tối đa 200,000đ/năm.</li>
                  </ul>
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_03?.[0]===1?benefits?.qlbs3khambenh:'Không hỗ trợ'}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  4. Trợ cấp nằm viện do tai nạn ( tối đa 60 ngày/năm)
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_04?.[0]===1?benefits?.qlbs4: 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  Giới hạn trợ cấp nằm viện do tai nạn (VNĐ/ngày)
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {dataIsu?.additional_04?.[0]===1?benefits?.namvientainan: 0}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>
                  5. Dịch vụ bảo lãnh viện phí
                </td>
                <td style={{ textAlign: "center", fontWeight: "bold" }}>
                  {benefits?.qlbs5}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalBenifitsDetail;
